export class TagItem {
  public epc: string;
  public upc: string;
  public isFound: boolean;
  public isSwipeable: boolean;

  constructor(epc: string, upc: string, isSwipeable: boolean, isFound: boolean) {
    this.epc = epc;
    this.upc = upc;
    this.isFound = isFound;
    this.isSwipeable = isSwipeable;
  }
}



// WEBPACK FOOTER //
// ./src/models/tagItem.ts